export const SEED_PHRASE_MODAL_ID = 'seedPhrase'
export const REVEAL_SEED_PHRASE_MODAL_ID = 'revealSeedPhrase'
export const RECOVERY_EMAIL_MODAL_ID = 'walletRecoveryEmail'
